const doc = [({"zh_tw":({"adminConstantHotelChildrenSettingType":({"complexChildrenSetting":"按子類別分開設置", "empty":"無設置", "none":"兒童不可住宿", "simpleChildrenSetting":"年齡自由設置，設置為兒童（+嬰兒）"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;